import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';  // withRouter to get location prop
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import TopbarLanguage from './TopbarLanguage';
import logo from '../../../images/logo-leanbox-wms-new.png';
import rightArrow from '../../../images/right_arrow.png';


class Topbar extends PureComponent {
  constructor() {
    super();
    this.state = { inputOpen: false, topbarMenuName: "", zoomLevel: 1 };
  }


  

  componentDidMount() {
    this.updateTopbarMenuName();
    this.detectZoom();
    // Add event listener to track zoom level changes
    window.addEventListener('resize', this.detectZoom);
  }

  componentDidUpdate(prevProps) {
    // Safely check if prevProps.location is defined and if pathname has changed
    if (prevProps.location && prevProps.location.pathname !== this.props.location.pathname) {
      this.updateTopbarMenuName();
    }
  }

   componentWillUnmount() {
    // Clean up event listener when component is unmounted
    window.removeEventListener('resize', this.detectZoom);
  }

   detectZoom = () => {
    const zoom = window.devicePixelRatio || 1; // Get zoom level
    this.setState({ zoomLevel: zoom });
  };

   goBack() {
     this.props.history.goBack();
  }

  updateTopbarMenuName() {
    const pathname = this.props.location.pathname;
    let topbarMenuName = '';

    if (pathname === "/wmsReports/po_to_grn_report") {
      topbarMenuName = "PO To GRN Report";
    } else if (pathname === "/wmsReports/po_sort_report") {
      topbarMenuName = "Receiving Short Report";
    }else if (pathname === "/wmsReports/inbound_delivery") {
      topbarMenuName = "Inbound Delivery Report";
    }else if (pathname === "/wmsReports/asn_invoice") {
      topbarMenuName = "ASN Invoice Report";
    }else if (pathname === "/wmsReports/receiving") {
      topbarMenuName = "Receiving Report";
    }else if (pathname === "/wmsReports/sales_return") {
      topbarMenuName = "Sales Return Report";
    }else if (pathname === "/wmsReports/sales_return_gr") {
      topbarMenuName = "Sales Return To GR Report";
    }else if (pathname === "/wmsReports/purchase_return_report") {
      topbarMenuName = "Purchase Return Report";
    }else if (pathname === "/wmsReports/putaway_report") {
      topbarMenuName = "Putaway Report";
    }else if (pathname === "/wmsReports/inbound_summary_report") {
      topbarMenuName = "Inbound Summary Report";
    }else if (pathname === "/wmsReports/health_check_report") {
      topbarMenuName = "Health Check Report";
    }else if (pathname === "/maintenance/cycleCount/cycleCountApprovalNew") {
      topbarMenuName = "CC Approval- Finance";
    }else if (pathname === "/maintenance/cycleCount/cycleCountApproval") {
      topbarMenuName = "CC Approval";
    }else if (pathname === "/maintenance/cycleCountConfirmation") {
      topbarMenuName = "CC Confirmation";
    }
    else if (pathname === "/maintenance/cycleCount/assignUser") {
      topbarMenuName = "CC Dashboard";
    }
    else if (pathname === "/secondaryupload/so_to_dispatch") {
      topbarMenuName = "SO To Dispatch";
    }else if (pathname === "/secondaryupload/packing_task_report") {
      topbarMenuName = "Packing Task";
    }else if (pathname === "/secondaryupload/incremental_data_report") {
      topbarMenuName = "PTL Incremental";
    }else if (pathname === "/secondaryupload/so_to_dispatch") {
      topbarMenuName = "SO To Dispatch";
    }else if (pathname === "/secondaryupload/complete_data_report") {
      topbarMenuName = "PTL Complete Report";
    }

    else if (pathname === "/secondaryupload/zone_master_report") {
      topbarMenuName = "Packing Station Zone Master Report";
    }else if (pathname === "/secondaryupload/party_packed_report") {
      topbarMenuName = "Party Packed Report";
    }else if (pathname === "/secondaryupload/ptl_api_put_qty_report") {
      topbarMenuName = "PTL API Put Qty Report";
    }else if (pathname === "/secondaryupload/ptl_data_report") {
      topbarMenuName = "PTL Data Report";
    }else if (pathname === "/secondaryupload/dispatch_confirm_report") {
      topbarMenuName = "Dispatch Confirmation Report";
    }else if (pathname === "/secondaryupload/completed_vans_report") {
      topbarMenuName = "Completed Van Report";
    }else if (pathname === "/secondaryupload/bill_editing_report") {
      topbarMenuName = "Bill Editing Report";
    }else if (pathname === "/secondaryupload/bill_report") {
      topbarMenuName = "Bill Report Report";
    }else if (pathname === "/secondaryupload/drs_box_id_report") {
      topbarMenuName = "DRS Box Id Report";
    }else if (pathname === "/wmsReports/cld_dispatch_report") {
      topbarMenuName = "CLD Dispatch Report";
    }else if (pathname === "/wmsReports/sto_transaction") {
      topbarMenuName = "STO Transaction Report";
    }else if (pathname === "/wmsReports/dues_report") {
      topbarMenuName = "Dues Report";
    }else if (pathname === "/secondaryupload/drs_cld_report") {
      topbarMenuName = "DRS CLD Report";
    }else if (pathname === "/wmsReports/sto_report") {
      topbarMenuName = "STO Report";
    }else if (pathname === "/wmsReports/reports/binconsolidation") {
      topbarMenuName = "Bin Consolidation";
    }else if (pathname === "/wmsReports/pick_task_report") {
      topbarMenuName = "Pick Task Report";
    }else if (pathname === "/wmsReports/pending_order_vs_available_qty") {
      topbarMenuName = "Pending Order VS Available Qty";
    }

    else if (pathname === "/cycleCount/cc_capture_reason") {
      topbarMenuName = "CC Capture Reason";
    }
     else if (pathname === "/picking/pickingTracking") {
      topbarMenuName = "Picking- Real Time Picking Tracking";
    }

    else if (pathname === "/picking/pickingPrioritization") {
      topbarMenuName = "Picking- Priority";
    }
    else if (pathname === "/wmsReports/mis_packing_report") {
      topbarMenuName = "Packing Task - Detailed";
    }


    // Update state only if the menu name has changed
    if (topbarMenuName !== this.state.topbarMenuName) {
      this.setState({ topbarMenuName });
    }
  }

  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,  // location prop is required
  };

  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility } = this.props;
    const { zoomLevel } = this.state;

    let zoomStyles = {};
    let menuNameSize = '18px'; // Default overlay width (no zoom)
    let menuNameMargin = '10px';
    let arrowWidth = "20px";
    let arrowHeight = "20px";
    let arrowMargin = ""
    
    if (zoomLevel >= 1.5) {
      zoomStyles = { transform: 'scale(1.5)', transition: 'transform 0.3s ease', top: '10%' };
      menuNameSize = '14px'; // Adjust overlay width for 150% zoom
      menuNameMargin = '10px';
      arrowWidth = "15px";
      arrowHeight = "15px";
      arrowMargin = "48px";
    } else if (zoomLevel >= 1.25) {
      zoomStyles = { transform: 'scale(1.25)', transition: 'transform 0.3s ease', top: '7%' };
      menuNameSize = '16px'; // Adjust overlay width for 125% zoom
      menuNameMargin = '20px';
      arrowWidth = "18px";
      arrowHeight = "18px";
      arrowMargin = "15px";
    } else if (zoomLevel > 1.1) {
      zoomStyles = { transform: 'scale(1.1)', transition: 'transform 0.3s ease' };
      menuNameSize = '17px'; // Adjust overlay width for 110% zoom
       menuNameMargin = '15px'
    }

    return (
      <div className="topbar">
        <div className="topbar__wrapper">
          <div className="topbar__left">
            <img style={{ width: '48%' }} src={require("../../../images/topbar_logo.svg")} />
            <img style={{ width: '12%' }} src={require("../../../images/Jarvis_logo.svg")} />
            <TopbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
          </div>

          <div className="topbar__profile" style={{ paddingTop: 15, marginLeft: '16%' }}>
            {this.state.topbarMenuName &&
             <button 
               onClick={() => this.goBack()}
              style={{ 
                border: 'none', 
                background: 'transparent', 
                cursor: 'pointer', 
                padding: 0, 
                marginRight: '10px' 
              }}
            >
             <img src={require('../../../images/right_arrow.png')} alt="Back" style={{ width: arrowWidth, height: arrowHeight, marginLeft: arrowMargin }} />
            </button>
          }
            <span style={{ marginTop: 24, fontSize: menuNameSize, fontWeight: 'bold', marginLeft: menuNameMargin }}>
              {this.state.topbarMenuName}
            </span>
          </div>

          <div className="topbar__right">
            <TopbarLanguage />
            <TopbarProfile />
          </div>
        </div>
      </div>
    );
  }
}

// Wrap the Topbar component with withRouter to get location
export default withRouter(Topbar);
